var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_72_251",
    "data-name": "Component 72 \\u2013 251",
    xmlns: "http://www.w3.org/2000/svg",
    width: 76,
    height: 27,
    viewBox: "0 0 76 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5793",
    "data-name": "Group 5793",
    transform: "translate(-16 -3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5900",
    "data-name": "Group 5900",
    transform: "translate(2)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Add",
    transform: "translate(69 23)",
    fill: "#0a47ba",
    fontSize: 20,
    fontFamily: "Avenir-Black, Avenir",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -20,
    y: 0
  }, "Add")), /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(14 3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Area_",
    "data-name": "Area ",
    width: 27,
    height: 27,
    fill: "#0a47ba",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon-2",
    "data-name": "Icon",
    transform: "translate(6.072 5.507)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line",
    y2: 15.421,
    transform: "translate(7.71)",
    fill: "none",
    stroke: "#124bb7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line-2",
    "data-name": "Line",
    x2: 15.421,
    transform: "translate(0 7.71)",
    fill: "none",
    stroke: "#124bb7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/add-icon.27ab50bacb477ce0117538bf070debd8.svg";
export { ForwardRef as ReactComponent };